export type AudioPlayerSpeed = '0.5x' | '1.0x' | '1.5x' | '2.0x'

export const AUDIO_PLAYER_SPEEDS: AudioPlayerSpeed[] = [
  '0.5x',
  '1.0x',
  '1.5x',
  '2.0x',
]

export type AudioPlayerPreviewState =
  | 'default'
  | 'playing'
  | 'paused'
  | 'disabled'

export const AUDIO_PLAYER_PREVIEW_STATES: AudioPlayerPreviewState[] = [
  'default',
  'playing',
  'paused',
  'disabled',
]

export const AUDIO_PLAYER_PREVIEW_STATE_LABELS: Record<
  AudioPlayerPreviewState,
  string
> = {
  default: 'Default',
  playing: 'Playing',
  paused: 'Paused',
  disabled: 'Disabled',
}

export type AudioPlayerProps = {
  /** Audio source URL (mp3, webm, blob:, https, etc.). */
  src?: string
  /** Initial volume 0–100. Defaults to 100. */
  defaultVolume?: number
  /** Initial playback speed. Defaults to 1.0x. */
  defaultSpeed?: AudioPlayerSpeed
  disabled?: boolean
  darkMode?: boolean
  className?: string
  /** Hide ±10s skip controls. */
  hideSkip?: boolean
  /** Hide volume control. */
  hideVolume?: boolean
  /** Hide speed control. */
  hideSpeed?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: AudioPlayerPreviewState
  /** Preview progress 0–100 (showcase). */
  previewProgress?: number
  /** Preview current time in seconds (showcase). */
  previewCurrentTime?: number
  /** Preview duration in seconds (showcase). */
  previewDuration?: number
  onPlay?: () => void
  onPause?: () => void
  onEnded?: () => void
}
